module.exports = __webpack_public_path__ + "./images/a9f430c78d7c045b688fe950fabcef7b.webp";